import { DATASET_LPG_VLGC } from '_legacy/models/Datasets';

const shouldAutoSelectPMT = (data) => {
    const loadParts = data?.loadLocationParts || [];
    const loadZone = data?.loadZone;
    const { hasAGLoad, hasUSGLoad } = HasAGOrUSGLoad(loadParts, loadZone);
    return hasAGLoad || hasUSGLoad;
};

export const selectBalticRouteAutomatically = (data, store) => {
    if (data?.datasetId !== DATASET_LPG_VLGC) {
        return null;
    }

    if (store?.amount && store?.amount !== '') {
        return null;
    }

    if (store?.unit?.value !== 'PMT' && !shouldAutoSelectPMT(data)) {
        return null;
    }

    const loadZone = data?.loadZone;
    const dischargeZone = data?.dischargeZone;
    const loadParts = data?.loadLocationParts || [];
    const dischargeParts = data?.dischargeLocationParts || [];

    const { hasAGLoad, hasUSGLoad } = HasAGOrUSGLoad(loadParts, loadZone);

    const isEastDischarge =
        dischargeParts.some(
            (part) =>
                part?.name?.includes('EAST') ||
                part?.displayName?.includes('EAST') ||
                part?.value?.includes('EAST')
        ) || dischargeZone?.includes('EAST');

    const isWestDischarge =
        dischargeParts.some(
            (part) =>
                part?.name?.includes('WEST') ||
                part?.displayName?.includes('WEST') ||
                part?.value?.includes('WEST')
        ) || dischargeZone?.includes('WEST');

    if (hasAGLoad) {
        return 'Rt/Ch';
    }

    if (hasUSGLoad) {
        if (isEastDischarge) {
            return 'H/Ch';
        }
        if (isWestDischarge) {
            return 'H/Fl';
        }
    }

    return null;
};

export const applyAutomaticBalticRouteSelection = (data, store) => {
    if (data?.datasetId === DATASET_LPG_VLGC && shouldAutoSelectPMT(data)) {
        if (store.unit?.value !== 'PMT' && store.onChangeUnit) {
            const pmtUnit = {
                value: 'PMT',
                label: 'PMT',
                shouldDisableAmount: false,
                shouldDisableBound: false,
                shouldDisableCurrency: false,
                shouldDisableDuration: false,
            };
            store.onChangeUnit(pmtUnit);
        }
    }

    const selectedRoute = selectBalticRouteAutomatically(data, store);

    if (selectedRoute && store.setBalticRoute) {
        const balticRouteOption = {
            value: selectedRoute,
            label: selectedRoute,
        };
        store.setBalticRoute(balticRouteOption);
    }
};
function HasAGOrUSGLoad(loadParts, loadZone) {
    const hasAGLoad =
        loadParts.some(
            (part) =>
                part?.name === 'AG' ||
                part?.displayName === 'AG' ||
                part?.value === 'AG'
        ) || loadZone === 'AG';

    const hasUSGLoad =
        loadParts.some(
            (part) =>
                part?.name === 'USG' ||
                part?.displayName === 'USG' ||
                part?.value === 'USG'
        ) || loadZone === 'USG';
    return { hasAGLoad, hasUSGLoad };
}
